import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SessionsPage from './pages/SessionsPage';
import PlaySession from './pages/PlaySession';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PricingPage from './pages/PricingPage';
import AccountPage from './pages/AccountPage';
import PaymentPage from './pages/PaymentPage';
import PaymentInstructionsPage from './pages/PaymentInstructionsPage';
import PaymentConfirmationPage from './pages/PaymentConfirmationPage';
import PayPalReturnPage from './pages/PayPalReturnPage';
import AdminPage from './pages/AdminPage';
import './assets/styles/style.css'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './hooks/useAuth';
import { logPageView } from './services/analyticsService';
import { initializeAnalytics, initializeFirebaseConnection } from './services/firebaseConfig';

// Component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Log page view whenever location changes
    logPageView(location.pathname);
    // Track route changes with Meta Pixel
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return null;
}

function App() {
  // Initialize analytics and connection monitoring when app mounts
  useEffect(() => {
    initializeAnalytics();
    initializeFirebaseConnection();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <PageTracker />
        <Routes>
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/play-session/:sessionId" element={<PlaySession  />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/instructions" element={<PaymentInstructionsPage />} />
          <Route path="/payment/confirmation" element={<PaymentConfirmationPage />} />
          <Route path="/payment/paypal/return" element={<PayPalReturnPage />} />
          <Route path="/admin" element={<AdminPage />} />
          
          {/* Optionally, add a catch-all route */}
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
